<template>
  <div>
    <v-toolbar flat color="white" class= "pt-3">
      <h1 class="heading dark-grey--text px-2 py-2">Switching Centre: {{switchingCentreInfo.name}}</h1>
    </v-toolbar>

    <v-toolbar flat color="white">
      <v-tabs  div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name)"
        >{{tab.displayName}}</v-tab>
      </v-tabs>
    </v-toolbar>

    <div v-if="displayContents('transactions')">
      <transactions
        :locationid="null"        
        :locationnetworkid="null"
        :locationnodeid="null"
        :switchingcentreid="this.$route.params.switchingCentreId"
        :transactions="switchingCentreTransactions"
        :descriptionlist="descriptionList"
        :salesvalue="salesValue"
        :cosvalue="cosValue"
        :expensevalue="expenseValue"
        :loanvalue="loanValue"
        @refreshTotals="sum()"
        @transactionAdded="getTransactions()"
      ></transactions>
    </div>
  <div v-if="displayContents('nodes')">
    
    <v-toolbar flat color="white">
        <v-btn color="primary" dark class="mb-2" @click="newDialog=true;cancelFields()" round >Add New Node</v-btn>
        <v-btn color="primary" dark class="mb-2" @click="associateDialog=true;cancelFields()" round >Associate Node</v-btn>
        <v-btn round color="primary"><v-icon>get_app</v-icon><download-excel
    :data="locationNodes"
    worksheet="export"
    :name="'Nodes_'+new Date().getTime() / 1000+'.xls'">
    Export to Excel
</download-excel></v-btn>
        <v-spacer></v-spacer>
        <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field>
    
    </v-toolbar>

    <!-- Add new item modal //////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->
    <!-- Add new item modal //////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->
    
    <v-dialog persistent v-model="newDialog" max-width="500px">
        <v-card>
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >ADD NODE</h1>
        </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    prepend-icon="edit"
                    v-model="editedItem.name"
                    label="*Node Name"
                    hint="This is the grouping of all Networks"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-switch v-model="editedItem.isActive"  label="isActive"></v-switch>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="saveNew">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

       <!-- Add existing node modal //////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->
    <!-- Add existing node modal  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->
    
    <v-dialog persistent v-model="associateDialog" max-width="500px">
        <v-card>
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >ADD NODE</h1>
        </v-toolbar>

          <v-card-text>
           <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                 <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    :items="allLocationNodes"
                    required
                    item-text="name"
                    item-value="id"
                    v-model="editedItem.locationNodeId"
                    label="*Associated Node"
                  >
               </v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-switch v-model="editedItem.isActive"  label="isActive"></v-switch>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="saveAssociatedNode">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

          <!-- EDIT //////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->
          <!-- EDIT //////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->

    <v-dialog persistent v-model="dialog" max-width="500px">
        <v-card>
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >EDIT NODE</h1>
        </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                   <v-flex xs12>
                  <v-text-field
                    prepend-icon="edit"
                    v-model="editedItem.name"
                    label="*Node Name"
                    hint="This is the grouping of all Networks"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
               
                <v-flex xs12 sm6 md4>
                  <v-switch v-model="editedItem.isActive"  label="isActive"></v-switch>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
     
<v-data-table
      :headers="headers"
      class="elevation-1"
      :search="search"
      :expand="expand"
      :pagination.sync="pagination"
      :loading="isloading"
      :items="locationNodes"
      item-key="id"
      :key="name"
      :rows-per-page-items="[10, 25, 50, 100]"
      align-center
      next-icon
      prev-icon
      style="cursor: pointer"
    >
      <template v-slot:items="props">
        <td class="justify-center layout px-0">
            <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
            <v-icon small @click="deleteItem(props.item)">delete</v-icon>
          </td>
          <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.name}}</td>
          <td @click="routerLinkToDetails(props.item)" class="text-xs-center" v-if="props.item.isActive===true"><v-chip small :class="`Active white--text caption my-2`">Active</v-chip></td>
          <td @click="routerLinkToDetails(props.item)" class="text-xs-center" v-else><v-chip small :class="`Inactive white--text caption my-2`">InActive</v-chip></td>

      </template>
      <!-- Custom Row count and Paging text -->
 <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      <!-- No data Display -->
    </v-data-table>

    </div>
    <div v-if="displayContents('devices')">
      <devicecrud :devices="switchingCentreDevices" @devicesSaved="getSwitchingCentreDevices()"></devicecrud>
    </div>
  </div>
</template>

<script>
import Api from "@/services/Api";
//import LocationsNodes from "@/components/LocationsNode.vue";
import Transactions from "@/components/Transactions.vue";
import Devices from "@/components/DeviceCrud.vue";

export default {
  props: ["switchingcentresummary", "totalitems"],
  components: {
    //locationnodes: LocationsNodes,
    devicecrud: Devices,
    transactions: Transactions,
  },
  data() {
    return {
            associateDialog: false,
            name: "",
            isloading:true,
            loading: false, 
            expand: false,
            search: "",
            dialog: false,
            newDialog: false,
            pagination: {},
            editedIndex: -1,
            editedItem: {
              locationNodeId: null,
      name: "",
      isActive: true,
      isDeleted: false
    },
    defaultItem: {
      name: "",
      locationNodeId: null,
      isActive: true,
      isDeleted:false
    },
    headers: [
      {
        text: "Action",
        align: "center"
      },
      {
        text: "Name",
        align: "center",
        value: "name"
      },
      {
        text: "Active",
        align: "center",
        value: "isActive"
      }
      
    ],
      allLocationNodes:[],
      locationNodes: [],
      switchingCentreDevices: [],
      salesValue: "",
      cosValue: "",
      expenseValue: "",
      loanValue: "",
      totals: [],
      switchingCentreTransactions: [],
      switchingCentreInfo: [],
      descriptionList:[],
      activeTabName:'',
      tabs: [        
        { name: "nodes", displayName: "Nodes" },
        { name: "devices", displayName: "Devices" },
        { name: "transactions", displayName: "Transactions" }             
      ]
    };
  },
  async created() {
    let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
        return el.url === '/switchingCentres/:switchingCentreId'})
     if (route.length > 0) {
      await this.$store.dispatch("setCurrentRoute", route[0]);
      if (this.authRead(this.$store.state.currentRoute) === true) {
        this.initialize();
      }
    } else {
      this.$router.push({ name: "SplashPage" });
    }
  },
  async mounted() {
      this.setActiveTabName('nodes')
  },
  computed: {
         pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
    },
  methods: {
     fetchLocationNodes() {   
       this.isloading=true
      Api()
        .get("/switchingCentres/" + this.$route.params.switchingCentreId)
        .then(response => {
          if(response.data.length>0){
            this.locationNodes = response.data[0].locationNodes;    
               this.isloading=false  
          }           
        });
    },
     fetchAllLocationNodes() {   
      Api()
        .get("/locationNodes/active")
        .then(response => {
          this.allLocationNodes = response.data;
        });
    },
    getTransactions() {
      this.descriptionList = [];
      Api()
        .get("/transactions/bySwitchingCentre/" + this.$route.params.switchingCentreId)
        .then(response => {
          this.switchingCentreTransactions = response.data;
          for (let i = 0; i < this.switchingCentreTransactions.length; i++) {
            if (
              !this.descriptionList.includes(
                this.switchingCentreTransactions[i].description
              )
            ) {
              this.descriptionList.push(this.switchingCentreTransactions[i].description);
            }
          }
          this.sum();
        });
    },
    getSwitchingCentreDevices() {
      Api()
        .get("/devices/switchingCentreDevices/" + this.$route.params.switchingCentreId)
        .then(response => {
          this.switchingCentreDevices = response.data;
        });
    },
    getSwitchingCentreInfo() {
      Api()
        .get("/switchingCentres/" + this.$route.params.switchingCentreId)
        .then(response => {
          this.switchingCentreInfo = response.data[0];
        });
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
    sum() {
      this.totals = [];
      this.salesValue = 0;
      this.cosValue = 0;
      this.expenseValue = 0;
      this.loanValue = 0;
      var res = {};

      this.switchingCentreTransactions.forEach(function(el) {
        res[el.transactionType] = res[el.transactionType]
          ? (res[el.transactionType] += +el.amount)
          : +el.amount;
      });
      // for (let i=0; i< res.length;i++){

      // }
      this.totals.push(
        Object.keys(res).map(function(el) {
          return { transactionType: el, amount: res[el] };
        })
      );
      for (let i = 0; i < this.totals[0].length; i++) {
        if (this.totals[0][i].transactionType === "Sales") {
          this.salesValue = this.totals[0][i].amount;
        }
        if (this.totals[0][i].transactionType === "Cost of Sales") {
          this.cosValue = this.totals[0][i].amount;
        }
        if (this.totals[0][i].transactionType === "Expense") {
          this.expenseValue = this.totals[0][i].amount;
        }
        if (this.totals[0][i].transactionType === "Loan") {
          this.loanValue = this.totals[0][i].amount;
        }
      }
    },
    initialize() {
      this.getTransactions();
      this.getSwitchingCentreInfo();
      this.getSwitchingCentreDevices();
      this.fetchLocationNodes();
      this.fetchAllLocationNodes()     
    },  
     routerLinkToDetails(item) {
      this.editedItem = Object.assign({}, item);
      this.$router.push({ path: "/locationNodes/" + this.editedItem.id });
    },
    editItem(item) {
      
      this.editedItem.name=item.name
      this.editedItem.locationNodeId=item.id
      this.editedIndex = this.locationNodes.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.locationNodeId=item.id
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedItem = Object.assign({}, item);
      confirm("Are you sure you want to delete this item?") &&
      Api().put("/locationnodes/" + this.editedItem.id, {
          isActive: false,
          isDeleted: true
        }).then(response=>
        {  this.fetchLocationNodes() 
        })        
        },
        cancelFields(){
          this.editedItem.name="",
          this.editedItem.locationNodeId=null
        },
    close() {
      this.dialog = false;
      this.newDialog=false;
      this.associateDialog=false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      }, 300);
    },
    save() {
      let proceed = true
      if(this.editedItem.name == '')
      {proceed = false
      confirm("Please enter a name")
      }
      if(proceed == true){
        Api().put("/locationnodes/" + this.editedItem.locationNodeId, {
          name: this.editedItem.name,
          switchingCentreId: this.$route.params.switchingCentreId,
          isActive: this.editedItem.isActive,
          isDeleted: !this.editedItem.isActive
        }).then(response=>{
        this.fetchLocationNodes() 
        this.locationNodes.push(this.editedItem);
        this.close();
        })
      }      
    },
    saveAssociatedNode(){
      let proceed = true
      if(this.editedItem.locationNodeId == null)
      {proceed = false
      confirm("Please select a node")
      }
      if(proceed == true){
       Api().put("/locationnodes/" + this.editedItem.locationNodeId, {
          switchingCentreId: this.$route.params.switchingCentreId,
          isActive: this.editedItem.isActive,
          isDeleted: this.editedItem.isDeleted
        }).then(response=>{
        this.fetchLocationNodes() 
        this.close();
        })
      }      
    },
      saveNew() {
      let proceed = true
      if(this.editedItem.name == "")
      {proceed = false
      confirm("Please enter a name")
      }
      if(proceed == true){
        Api().post("/locationnodes", {
          name: this.editedItem.name,          
          switchingCentreId: this.$route.params.switchingCentreId,
          isActive: this.editedItem.isActive,
          isDeleted: this.editedItem.isDeleted
        }).then(response=>{
          this.fetchLocationNodes()
        this.close();
        })
      }      
  }}
};
</script>
